// Module
var code = "<div class=\"input-group\"> <input type=\"text\" class=\"form-control\" ng-attr-id=\"{{dateRangeCtrl.inputId}}\" ng-init=\"dateRangeCtrl.initRangePicker()\" ng-attr-name=\"{{dateRangeCtrl.inputName}}\" value=\"\"/> <span class=\"input-group-addon\" ng-click=\"dateRangeCtrl.focusInput()\"><i class=\"fa fa-calendar\"></i></span> </div>";
// Exports
module.exports = code;